<template>
  <div class="qr-code" v-html="svg"/>
</template>

<script>
import QRCode from 'qrcode-svg';

export default {
  props: {
    content: {
      type: String|Number,
      default: '',
    },
    padding: {
      type: Number,
      default: 2,
    },
    width: {
      type: Number,
      default: 256,
    },
    height: {
      type: Number,
      default: 256,
    },
    color: {
      type: String,
      default: '#000000',
    },
    background: {
      type: String,
      default: '#ffffff',
    },
    ecl: {
      type: String,
      default: 'H', // L, M, Q, H
    },
  },
  computed: {
    svg() {
      const qrcode = new QRCode({
        content: this.content,
        padding: this.padding,
        width: this.width,
        height: this.height,
        color: this.color,
        background: this.background,
        ecl: this.ecl,
        join: true,
        xmlDeclaration: false,
        container: 'svg-viewbox'
      });
      return qrcode.svg();
    }
  }
}
</script>

<style>

</style>
